import {
  add,
  cloneDeep
} from "lodash";
const changeOrigin = (rule, value, callback) => {
  if (value) {
    if (/[ ]|[\u4E00-\u9FA5]/g.test(value)) {
      callback(new Error("不能输入汉字与空格，请检查"));
    }
  } else {
    callback();
  }
};

const validatorMoney = (rule, value, callback) => {
  let isVal = value.toString(); //先转换成字符串类型
  let regnumDot = /[^\d.]/g;
  /* if (/[ ]|[\u4E00-\u9FA5]/g.test(isVal)) {
    callback(new Error("不能输入汉字与空格，请检查"));
  } */
  if (isVal === "") {
    callback(new Error("请输入金额"));
  } else if (isVal == 0) {
    callback(new Error("金额不可为0"));
  }
};

const addForm = {
  invest_target: "", // 变现目标
  account_id: "", //子账户ID
  version: "", // 投放版本，只有选择巨量的时候才生效
  domain: "",
  title: "",
  origin: "",
  system_create: "",
  lisiten_appid: "",
  lisiten_app_system: "",
  release_date: "",
  all_budget: "",
  purchase_price: "",
  ratio: "",
  date: "",
  service_ratio: "",
  service_date: "",
  channel_type: "2",
  admin_id: "",
  akey: "",
  event_id: "",
  event_type: "",
  event_name: "",
  note: "",
  conversion_target: "", // 转化目标
};

const changeForm = {
  proceeds_user: "",
  ad_id: "",
  ad_name: "",
  admin_id: "",
  channel: "",
  platform: "",
  admin_date: "",
  note: "",
  note_date: "",
  channel_type: "",
}

const changeFormOne = {
  admin_id: "",
  channel: "",
  platform: "",
  akey: "",
  access_token: "",
  admin_date: "",
  event_id: "",
  event_name: "",
  settlement_date: "",
  note: "",
  note_date: "",
  id: "",
  channel_type: "",
}

const juliangConversionList = [{
    label: "激活",
    value: 1
  },
  {
    label: "付费",
    value: 2
  },
  {
    label: "次留",
    value: 3
  },
  {
    label: "关键行为",
    value: 4
  },
]
const baiduConversionList = [{
    label: "激活",
    value: 1
  },
  {
    label: "付费",
    value: 2
  },
  {
    label: "关键行为",
    value: 4
  },
]
const tengxunConversionList = [{
    label: "激活",
    value: 1
  },
  {
    label: "付费",
    value: 2
  },
  {
    label: "次留",
    value: 3
  },
  {
    label: "关键行为",
    value: 4
  },
  {
    label: "下单",
    value: 5
  },
]

export const myMixins = {
  data() {
    return {
      sort: {
        prop: "",
        order: "",
      },
      searchForm: {
        search: "",
        channel: [],
        admin_id: [],
        system_create: "99", // todo
        currentPage: 1,
      },
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: {
        data: [],
        total: 0,
        loading: false,
        currentPage: 1,
        pageSize: 10,
      },
      addForm,
      changeForm,
      changeRules: {
        proceeds_user: [{
          required: true,
          message: "请填写收款账户"
        }],
        ad_id: [{
          required: true,
          message: "请填写订单ID"
        }],
        ad_name: [{
          required: true,
          message: "请填写计划名称"
        }],
        admin_id: [{
          required: false
        }],
        admin_date: [{
          required: false
        }],
        note_date: [{
          required: false
        }],
      },
      changeFormOne,
      changeFormOneRules: {
        event_id: [{
          required: true,
          message: "请填写关键行为ID",
          trigger: "change"
        }, ],
        event_name: [{
          required: true,
          message: "请填写关键行为名称",
          trigger: "change"
        }, ],
        event_nameNo: [{
          required: false
        }],
        note_date: [{
          required: false
        }],
        note: [{
          required: true,
          message: "请填写备注",
          trigger: "change"
        }, ],
      },
      platformChannelType: [{
          label: "自营渠道",
          value: "1",
        },
        {
          label: "代理渠道",
          value: "2",
        },
      ],
      platformChannelTypeEdie: [{
          label: "自营渠道",
          value: "1",
          disa: false,
        },
        {
          label: "代理渠道",
          value: "2",
          disa: false,
        },
        {
          label: "自然渠道",
          value: "3",
          disa: true,
        },
      ],
      addFormRules: {
        title: [{
          required: true,
          message: "请输入渠道名称",
          trigger: "blur"
        }],
        origin: [{
            required: true,
            message: "请输入渠道号",
            trigger: "blur"
          },
          {
            validator: changeOrigin,
            trigger: "blur"
          },
        ],
        invest_target: [{
          required: true,
          message: "请选择变现目标",
          trigger: "change"
        }, ],
        conversion_target: [{
          required: true,
          message: "请选择转化目标",
          trigger: "change"
        }, ],
        event_id: [{
          required: true,
          message: "请填写关键行为ID",
          trigger: "change"
        }, ],
        event_idNo: [{
          required: false
        }],
        event_name: [{
          required: true,
          message: "请填写关键行为名称",
          trigger: "change"
        }, ],
        event_nameNo: [{
          required: false
        }],
        event_type: [{
          required: true,
          message: "请填写关键行为类型",
          trigger: "change"
        }, ],
        release_date: [{
          required: true,
          message: "请填写发布时间",
          trigger: "change"
        }, ],
        all_budget: [{
            required: true,
            message: "请填写总预算",
            trigger: "change"
          },
          {
            validator: validatorMoney,
            trigger: "change"
          },
        ],
        account_id: [{
          required: true,
          message: "请填写子账户ID",
          trigger: "change"
        }, ],
        note: [{
          required: true,
          message: "请填写备注",
          trigger: "change"
        }, ],
        ratio: [{
          required: true,
          message: "请填写备注",
          trigger: "change"
        }, ],
        purchase_price: [{
            required: true,
            message: "请填写买量单价",
            trigger: "change"
          },
          {
            validator: validatorMoney,
            trigger: "change"
          },
        ],
        event_typeNo: [{
          required: false
        }],
      },
      column: [{
          prop: "system_create",
          label: "投放方式",
        },
        {
          prop: "title",
          label: "渠道名称",
        },
        {
          prop: "origin",
          label: "渠道",
        },
        {
          prop: "admin_name",
          label: "渠道负责人",
        },
        {
          prop: "info",
          label: "其他信息",
          width: 200,
        },
        {
          prop: "day",
          label: "日期",
        },
        {
          prop: "device_new_all",
          label: "归因新增",
          sortable: "custom",
        },
        {
          prop: "statistics",
          label: "收入统计",
        },
        {
          prop: "time_add",
          label: "添加时间",
        },
        {
          prop: "option",
          label: "操作",
          width: 180,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() < new Date().getTime() - 8.64e7;
          return time.getTime() < new Date().getTime() - 2592000000;
        },
      },
      //备注时间限制
      pickerOptionsNote: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 2592000000; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      releasePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 2592000000; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      juliangConversionList,
      baiduConversionList,
      tengxunConversionList,
    };
  },
  methods: {
    // 重置新增表单的参数
    resetAddForm() {
      return cloneDeep(addForm)
    },
    // 重置changeFormOne 表单
    resetChangeFormOne() {
      return cloneDeep(changeFormOne)
    },
    //  重置changeForm 表单
    resetChangeForm() {
      return cloneDeep(changeForm)
    },
  }
};